// extracted by mini-css-extract-plugin
export default {"footer_con":"footer_footer_con__mUxdD","footer_inner_con":"footer_footer_inner_con__mVxik"};